import React, { useEffect } from 'react';
import urlParse from 'url-parse';
import { IdProvider } from '@radix-ui/react-id';
import { builder } from '@builder.io/react';
import { Inter } from 'next/font/google';

import Head from 'next/head';
import 'slick-carousel/slick/slick.css';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/neo.css';
import 'react-scale/components/elements/global.scss';
import 'react-scale/components/elements/hubspot-form/index.css';
import { TransformXContextProvider } from 'react-scale/lib/transformx/context';
import { ThemeProvider } from 'next-themes';
// import { DefaultSeo } from 'next-seo';
// import SEO from 'react-scale/lib/next-seo.config';
import { Analytics } from '@vercel/analytics/react';
import { useUTMParams } from 'react-scale/hooks/use-utm-params';

const BUILDER_API_KEY = process.env.NEXT_PUBLIC_BUILDER_API_KEY;
builder.init(BUILDER_API_KEY);

const inter = Inter({
  subsets: ['latin'],
  variable: '--font-inter'
});

export default function MyApp({ Component, pageProps, err }) {
  useUTMParams();

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const { query } = urlParse(window.location.href, true);
      try {
        if (
          query.utm_campaign ||
          query.utm_source ||
          query.utm_medium ||
          query.utm_term ||
          query.utm_content
        ) {
          window.sessionStorage.setItem(
            'utm_params',
            JSON.stringify({
              utm_campaign: query.utm_campaign ?? window.sessionStorage.utm_campaign,
              utm_source: query.utm_source ?? window.sessionStorage.utm_source,
              utm_medium: query.utm_medium ?? window.sessionStorage.utm_medium,
              utm_term: query.utm_term ?? window.sessionStorage.utm_term,
              utm_content: query.utm_content ?? window.sessionStorage.utm_content
            })
          );
        }
      } catch (error) {
        // NOTE: ignore error, using localStorage/sessionStorage is disabled in incognito.
      }
    }
  }, []);

  return (
    <ThemeProvider
      defaultTheme="dark"
      forcedTheme={Component.theme || null}
      enableSystem={false}
      enableColorScheme={false}
    >
      <TransformXContextProvider>
        <IdProvider>
          {/* <DefaultSeo {...SEO} /> */}
          <Head>
            <style
              type="text/css"
              dangerouslySetInnerHTML={{
                __html: `
                :root {
                  --font-inter: ${inter.style.fontFamily};
                }
              `
              }}
            />
          </Head>
          <main className="font-sans">
            <Component {...pageProps} err={err} />
          </main>
          <Analytics />
        </IdProvider>
      </TransformXContextProvider>
    </ThemeProvider>
  );
}
